import type { FC } from 'react';
import iconSrc from 'src/assets/prisma-icon-white-colored-dot.svg';
import logoSrc from 'src/assets/prisma-logo-short-white-colored-dot.svg';
import { cn } from 'src/utils/cn';

export const Logo: FC<{ mode?: 'default' | 'icon'; className?: string }> = ({
  mode = 'default',
  className,
}) => {
  return (
    <img
      alt="logo of Prisma"
      src={mode === 'icon' ? iconSrc : logoSrc}
      className={cn('block', className)}
    />
  );
};
